import { createModal } from "./coreModal.js";

export function openVideoModal({ id }) {
  const modal = createModal({ modifier: "l-modal--video" });
  if (!modal) return;

  const iframe = document.createElement("iframe");
  iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
  iframe.allow = "autoplay; encrypted-media";
  iframe.allowFullscreen = true;

  modal.body.appendChild(iframe);

  const originalClose = modal.close;
  modal.close = () => {
    iframe.src = ""; // 再生停止
    originalClose();
  };
}
